import $ from "jquery";
import Feedbacks from "@bd-utils/feedback";
import convertToBudgetFormat from "@bd-utils/convertToBudgetFormat";
import Budget from "./budget";
import Timer from "./timer";
import { updateAttributes } from "@bd-core/firebase-actions";
import { updateRoomSpending } from "@bd-stores/game-progress";
import { getState, store } from "@bd-stores/store";
import CONFIG from "@bd-core/config";

export default class Incidents {
    constructor() {
        this.elms = {
            nextButton: ".js-next-incident",
            incidentsMark: ".js-incidents-mark",
            incidents: ".js-incidents",
            incidentItem: ".js-incident-feed",
            finishIncident: ".js-finish-incident",
            incidentPopup: ".js-incidents-popup",
            incidentTitle: ".popup__feedback-title",
            incidentSubtitle: ".popup__feedback-subtitle",
            consequences: ".consequences",
            consequenceMain: ".consequence__main",
        };

        this.isLoading = false;
        this.feedback = new Feedbacks();
        this.budget = new Budget();
        this.timer = new Timer();
        this.incidentsCost = 0;
        this.incidentsTime = 0;
        this.questionId = null;
        this.currentRoomId = null;
        this.incidentsProcessed = false;
        this.isShown = false;
        return this;
    }

    init() {
        $(this.elms.finishIncident).on("click", this.finishIncident.bind(this));
        this.incidentsProcessed = false;
    }

    /**
     * Get the localStorage key for shown incidents based on game progress ID
     * @returns {string} - The localStorage key for this game session
     */
    getIncidentsStorageKey() {
        const gameProgressId = CONFIG.game.id;
        return `shownIncidents_${gameProgressId}`;
    }

    /**
     * Check if incident popup for a specific question ID has been shown
     * @param {string} questionId - The question ID to check
     * @returns {boolean} - True if incident has been shown, false otherwise
     */
    hasIncidentBeenShown(questionId) {
        try {
            const storageKey = this.getIncidentsStorageKey();
            const shownIncidents = localStorage.getItem(storageKey);
            if (!shownIncidents) return false;

            const shownIncidentsArray = JSON.parse(shownIncidents);
            return shownIncidentsArray.includes(String(questionId));
        } catch (error) {
            console.error("Error checking shown incidents:", error);
            return false;
        }
    }

    /**
     * Mark incident popup for a specific question ID as shown
     * @param {string} questionId - The question ID to mark as shown
     */
    markIncidentAsShown(questionId) {
        try {
            const storageKey = this.getIncidentsStorageKey();
            let shownIncidents = localStorage.getItem(storageKey);
            let shownIncidentsArray = shownIncidents
                ? JSON.parse(shownIncidents)
                : [];

            if (!shownIncidentsArray.includes(String(questionId))) {
                shownIncidentsArray.push(String(questionId));
                localStorage.setItem(
                    storageKey,
                    JSON.stringify(shownIncidentsArray),
                );
            }
        } catch (error) {
            console.error("Error marking incident as shown:", error);
        }
    }

    populateIncidents(roomAnswers, roomData) {
        this.currentRoomId = roomData.room_id || roomData.id;
        const totalQuestions = roomData.questions.length;

        if (totalQuestions === 0) return;
        else if (totalQuestions === 1) {
            $(this.elms.nextButton).prop("disabled", true);
            $(this.elms.finishIncident).prop("disabled", false);
        }

        const incidentTemplate = $("#incidents-template").html();
        const incidentsContainer = $(this.elms.incidents);
        incidentsContainer.empty();
        $(this.elms.incidentsMark).empty();

        this.currentIncidentQuestions = [];

        let index = 1;
        for (const questionId in roomAnswers) {
            if (this.hasIncidentBeenShown(questionId)) continue;

            const $incident = $(incidentTemplate).clone();
            const answerObj = roomAnswers[questionId];
            const answerId = answerObj?.answer || answerObj;
            const isGotIncident = answerObj?.isGotIncident || false;
            const percentage = answerObj?.incidentPercentage || 0;

            this.questionId = questionId;

            if (Number(percentage) === 0) {
                continue;
            }

            const question = roomData.questions.find(
                (q) => String(q.question_id) === String(questionId),
            );
            if (!question) continue;
            const answer = question.answers.find(
                (a) => String(a.answer_id) === String(answerId),
            );
            if (!answer) continue;

            const incident = answer.incident;

            $incident.attr("data-id", index);
            $incident.attr("data-question-id", questionId);
            $incident.attr("id", "incident-" + index);
            $incident.addClass("is-active");

            $incident.addClass(isGotIncident ? "" : "is-positive");
            const incidentTitle = isGotIncident
                ? incident.incident_title
                : incident.incident_dodge_title;
            const incidentSubtitle = isGotIncident
                ? incident.incident_subtitle
                : incident.incident_dodge_subtitle;
            $incident.find(this.elms.incidentTitle).text(incidentTitle || "");
            $incident
                .find(this.elms.incidentSubtitle)
                .html(incidentSubtitle || "");

            if (isGotIncident) {
                if (incident.incident_cost !== "0") {
                    const incidentCost = incident?.incident_cost ?? 0;
                    const consequenceTemplate = $(
                        "#consequence-budget-needed-template",
                    ).html();
                    const $consequence = $(consequenceTemplate).clone();

                    $consequence
                        .find(this.elms.consequenceMain)
                        .text(convertToBudgetFormat(incident.incident_cost));
                    $incident.find(this.elms.consequences).append($consequence);
                    this.incidentsCost = incidentCost;

                    this.saveIncidentCost(incidentCost, questionId);
                }
                if (incident.time_risk !== "0") {
                    const timeRisk = incident?.time_risk ?? 0;
                    const consequenceTemplate = $(
                        "#consequence-time-lost-template",
                    ).html();
                    const $consequence = $(consequenceTemplate).clone();
                    this.incidentsTime = timeRisk;

                    $consequence
                        .find(this.elms.consequenceMain)
                        .text(`${incident.time_risk} secs`);
                    $incident.find(this.elms.consequences).append($consequence);
                }
            }

            // if (index === 1) {
            //     $incident.addClass("is-active");
            // } else {
            //     $incident.removeClass("is-active");
            // }

            $(
                `${this.elms.incidentItem}[data-question-id="${this.questionId}"]`,
            ).addClass("is-active");

            incidentsContainer.append($incident);
            $(this.elms.incidentsMark).append(
                `<span class="js-incidents-mark${
                    index === 1 ? " is-active" : ""
                }" data-id="${index}"></span>`,
            );

            this.currentIncidentQuestions.push(questionId);
            index++;
        }

        if (incidentsContainer.children().length > 0) {
            this.show();
        } else {
            this.finishIncident();
        }

        this.incidentsProcessed = true;
    }

    isGotIncident(incidentPercentage) {
        const random = Math.random() * 100;
        return random <= parseInt(incidentPercentage);
    }

    saveIncidentCost(incidentCost, questionId) {
        if (
            !this.currentRoomId ||
            incidentCost === undefined ||
            incidentCost === null ||
            !questionId
        ) {
            return;
        }

        const currentSpending = getState().gameProgress.spending || {};
        const roomSpending = currentSpending[this.currentRoomId] || {
            incidentCosts: [],
            actionCosts: [],
            processedQuestions: [],
        };
        const processedQuestions = Array.isArray(
            roomSpending.processedQuestions,
        )
            ? roomSpending.processedQuestions
            : [];

        if (processedQuestions.includes(questionId)) {
            return;
        }

        store.dispatch(
            updateRoomSpending({
                roomId: this.currentRoomId,
                incidentCost: Number(incidentCost),
                processedQuestion: questionId,
            }),
        );

        const updatedSpending = getState().gameProgress.spending || {};
        updateAttributes({ spending: updatedSpending });
    }

    finishIncident() {
        this.hide();

        if (
            this.currentIncidentQuestions &&
            this.currentIncidentQuestions.length > 0 &&
            !this.isShown
        ) {
            this.currentIncidentQuestions.forEach((questionId) => {
                this.markIncidentAsShown(questionId);

                if (this.incidentsCost > 0) {
                    this.budget.addIncidentBudgetForQuestion(
                        this.incidentsCost,
                        this.currentRoomId,
                        questionId,
                    );
                }

                this.isShown = true;
            });

            if (this.incidentsTime > 0) {
                this.timer.applyTimePenalty(this.incidentsTime);
            }
        }

        setTimeout(() => {
            this.incidentsCost = 0;
            this.incidentsTime = 0;
            this.isShown = false;
            this.feedback.show();
        }, 1500);
    }

    nextIncident() {
        const elms = this.elms;
        const $nextButton = $(elms.nextButton);

        const onCLickHandler = function () {
            const $currentIncident = $(".js-incident-feed.is-active");
            const $nextIncident = $currentIncident.next();
            const $incidentIndex = $currentIncident.data("id");
            const allIncidents = $(elms.incidentItem).length;
            const transform = 100 * $incidentIndex;
            const $currentMark = $(".js-incidents-mark.is-active");

            if ($nextIncident.length > 0) {
                $nextIncident.addClass("is-active");
                $currentIncident.removeClass("is-active");
                $currentMark.removeClass("is-active");
                $currentMark.next().addClass("is-active");
                $(elms.incidents).css({
                    transform: "translateX(-" + transform + "%)",
                });

                if (allIncidents === $incidentIndex + 1) {
                    $(elms.nextButton).attr("disabled", "disabled");
                    $(elms.finishIncident).attr("disabled", null);
                }
            }
        };

        $nextButton.on("click", onCLickHandler);
    }

    incidentNav() {
        const elms = this.elms;

        $(elms.incidentsMark).on("click", function () {
            const allIncidents = $(elms.incidentItem).length;
            const incidentIndex = $(this).data("id");
            const transform = 100 * (incidentIndex - 1);

            $(elms.incidentsMark).removeClass("is-active");
            $(elms.incidentItem).removeClass("is-active");
            $(this).addClass("is-active");
            $('.js-incident-feed[data-id="' + incidentIndex + '"]').addClass(
                "is-active",
            );
            $(elms.incidents).css({
                transform: "translateX(-" + transform + "%)",
            });

            if (allIncidents === incidentIndex) {
                $(elms.nextButton).attr("disabled", "disabled");
                $(elms.finishIncident).attr("disabled", null);
            } else {
                $(elms.nextButton).attr("disabled", null);
                $(elms.finishIncident).attr("disabled", "disabled");
            }
        });
    }

    show() {
        const elms = this.elms;
        const $this = $(elms.incidentPopup);
        const $children = $this.children();

        if ($children.length === 1) {
            $(elms.nextButton).attr("disabled", "disabled");
            $(elms.finishIncident).attr("disabled", null);
        }

        $this.addClass("is-open");
    }

    hide() {
        const elms = this.elms;
        $(elms.incidentPopup).removeClass("is-open");
    }
}
